import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/home',
    },
    {
      path: '/404',
      name: '404',
      meta: { breadcrumbLabel: '404' },
      component: () => import('@/views/404.vue')
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/home',
      name: 'home',
      meta: { breadcrumbLabel: '首页' },
      component: () => import('@/views/home.vue')
    },
    {
      path: '/about',
      name: 'about',
      meta: { breadcrumbLabel: '关于博商' },
      component: () => import('@/views/about/about.vue'),
      // children: [
      //   {
      //     path: '/dashboard',
      //     name: 'dashboard',
      //     component: () => import('@/views/course.vue'),
      //   },
      //   {
      //     path: '/aboutA',
      //     name: 'aboutA',
      //     component: () => import('@/views/about.vue'),
      //   },
      // ]
    },
    {
      path: '/responsibility',
      name: 'responsibility',
      meta: { breadcrumbLabel: '社会责任' },
      component: () => import('@/views/about/responsibility.vue'),
    },
    {
      path: '/boSumDynamic',
      name: 'boSumDynamic',
      meta: { breadcrumbLabel: '博商动态' },
      component: () => import('@/views/about/boSumDynamic.vue'),
    },
    {
      path: '/newsDynamic',
      name: 'newsDynamic',
      meta: { breadcrumbLabel: '新闻动态' },
      component: () => import('@/views/about/newsDynamic.vue'),
    },
    {
      path: '/newsDetails/:officialWebsiteId',
      name: 'newsDetails',
      meta: { breadcrumbLabel: '新闻动态详情' },
      component: () => import('@/views/about/newsDetails.vue'),
    },
    {
      path: '/courseConsultList',
      name: 'courseConsultList',
      meta: { breadcrumbLabel: '课程资讯' },
      component: () => import('@/views/about/courseConsultList.vue'),
    },
    {
      path: '/courseConsultDetail/:officialWebsiteId',
      name: 'courseConsultDetail',
      meta: { breadcrumbLabel: '课程资讯详情' },
      component: () => import('@/views/about/courseConsultDetail.vue'),
    },
    {
      path: '/industrialReport',
      name: 'industrialReport',
      meta: { breadcrumbLabel: '行业报告' },
      component: () => import('@/views/about/industrialReport.vue'),
    },
    {
      path: '/reportDetails/:industryReportId',
      name: 'reportDetails',
      meta: { breadcrumbLabel: '行业报告详情' },
      component: () => import('@/views/about/reportDetails.vue'),
    },
    {
      path: '/boSumPublish',
      name: 'boSumPublish',
      meta: { breadcrumbLabel: '博商出版' },
      component: () => import('@/views/about/boSumPublish.vue'),
    },
    {
      path: '/teaching',
      name: 'teaching',
      meta: { breadcrumbLabel: '教学中心' },
      component: () => import('@/views/teaching.vue')
    },
    {
      path: '/course',
      name: 'course',
      meta: { breadcrumbLabel: '课程服务' },
      component: () => import('@/views/course/course.vue'),
    },
    {
      path: '/courseServer',
      name: 'courseServer',
      meta: { breadcrumbLabel: '课程服务' },
      component: () => import('@/views/course/courseServer.vue'),
      children: [
        {
          path: 'personalLearning',
          name: 'personalLearning',
          meta: { breadcrumbLabel: '个人学习系统班' },
          component: () => import('@/views/course/personalLearnClass.vue'),
        },
        {
          path: 'teamLearning',
          name: 'teamLearning',
          meta: { breadcrumbLabel: '团队共学研习社' },
          component: () => import('@/views/course/teamLearnTrainSociety.vue'),
        },
        {
          path: 'accompanyRunners',
          name: 'accompanyRunners',
          meta: { breadcrumbLabel: '陪跑系列' },
          component: () => import('@/views/course/accompanyRunSeries.vue'),
        },
        {
          path: 'lead',
          name: 'lead',
          meta: { breadcrumbLabel: '领跑系列' },
          component: () => import('@/views/course/lead.vue'),
        },
        {
          path: 'onLine',
          name: 'onLine',
          meta: { breadcrumbLabel: '线上系列' },
          component: () => import('@/views/course/onLine.vue'),
        },
      ]
    },
    {
      path: '/course',
      name: 'course',
      meta: { breadcrumbLabel: '课程服务' },
      component: () => import('@/views/course/course.vue'),
    },
    {
      path: '/sidebar',
      name: 'sidebar',
      meta: { breadcrumbLabel: 'sidebar' },
      component: () => import('@/components/sidebar.vue'),
    },
    {
      path: '/consult',
      name: 'consult',
      meta: { breadcrumbLabel: '课程资讯' },
      component: () => import('@/views/course/consult.vue'),
    },


    {
      path: '/combat',
      name: 'combat',
      meta: { breadcrumbLabel: '实战导师' },
      component: () => import('@/views/combat/combat.vue')
    },
    {
      path: '/fieldIInstructor',
      name: 'fieldIInstructor',
      meta: { breadcrumbLabel: '实战导师' },
      component: () => import('@/views/combat/fieldIInstructor.vue')
    },
    {
      path: '/student',
      name: 'student',
      meta: { breadcrumbLabel: '企业学员' },
      component: () => import('@/views/student/student.vue')
    },
    {
      path: '/outstandingAlumni',
      name: 'outstandingAlumni',
      meta: { breadcrumbLabel: '优秀校友' },
      component: () => import('@/views/student/outstandingAlumni.vue')
    },
    {
      path: '/studentCase',
      name: 'studentCase',
      meta: { breadcrumbLabel: '学员案例' },
      component: () => import('@/views/student/studentCase.vue')
    },
    {
      path: '/join',
      name: 'join',
      meta: { breadcrumbLabel: '加入博商' },
      component: () => import('@/views/join.vue')
    },
    {
      path: '/recruit',
      name: 'recruit',
      meta: { breadcrumbLabel: '加入博商' },
      component: () => import('@/views/recruit.vue')
    },
  ],
  scrollBehavior: () => ({ y: 0 })
})



// WEBPACK FOOTER //
// ./src/router/index.js